import React, { useRef } from 'react'
import { capabilitiesErrorAtom } from 'atoms/capabilities'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Tabs, type Tab } from '@node-space/ui-components'
import { logSentryErrorAndGetTraceId } from '@node-space/utils'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { PageHeader } from 'components/header/PageHeader'
import { customerModelAtom } from 'pages/Customers/atoms/customersAtoms'
import { CustomersList } from 'pages/Customers/CustomersList/CustomersList'
import { AddCustomerAgreementCta } from './AddCustomer/AddCustomerAgreementCta'
import { CustomersListV2 } from './CustomersListV2/CustomersListV2'

export const CustomersV2 = () => {
  const { t } = useTranslation()
  const capabilitiesError = useAtomValue(capabilitiesErrorAtom)
  const customerModel = useAtomValue(customerModelAtom)
  const refetchRef = useRef<() => void>(() => {})

  if (capabilitiesError) {
    const sentryTraceId = logSentryErrorAndGetTraceId(
      `Failed API request to /v1/capabilities/bulk with status ${capabilitiesError?.status}`,
      capabilitiesError
    )

    return (
      <RequestErrorStatusCard
        title={t('errorMessages.featureErrorTitle')}
        sentryTraceId={sentryTraceId}
      />
    )
  }

  const AddButton = <AddCustomerAgreementCta refetchCustomers={() => refetchRef.current()} />

  const tabs: Tab[] = [
    {
      id: 'v2-customer-onboarding',
      header: t('customers.tabs.v2Onboarding'),
      content: (
        <CustomersListV2
          AddButton={AddButton}
          onRefetch={refetch => {
            refetchRef.current = refetch
          }}
        />
      ),
      testId: 'v2-onboarding-tab',
    },
    {
      id: 'v1-customer-onboarding',
      header: t('customers.tabs.v1Onboarding'),
      content: customerModel ? (
        <CustomersList customerModel={customerModel} hideEpcDashboard hideAddButton />
      ) : null,
      testId: 'v1-onboarding-tab',
    },
  ]

  return (
    <Box paddingB={8}>
      <PageHeader description={t('customers.descriptionV2')} renderRightSection={AddButton} />
      <Tabs tabs={tabs} defaultTabId="v2-customer-onboarding" testId="onboarding-tabs" />
    </Box>
  )
}
